export const NIG_ID = `e1662307-ee3e-40e0-a65b-77db96d6638a`
export const ANDI_ID = `c382eb45-1274-40e4-bd84-48257ddf3399`
export const HAVEN_ID = `a14178fb-b5fb-460a-9748-795cfb91cc72`
export const ADMIRAL_ID = `18f23cb2-9e12-4ff5-8b84-2ccbd6bf0b0a`
export const RSA_ID = `6798f796-1307-49c1-8841-aa4671b7e681`
